export default __webpack_public_path__ + "static/media/max-investment.4855f9ba.svg";